import whatsapp_img from "./images/WhatsAppButtonWhiteSmall.png" 
import { go_to_shop } from "./libs/common";

function load_whatsapp_button() {
    console.debug("Loading whatsapp button.")
    document.getElementById("whatsapp_button_img").src = whatsapp_img;
    document.getElementById("whatsapp_button_div").onclick = function () {
        let wa_link = "https://wa.me/7899665828";
        window.open(wa_link, '_blank').focus();
    }
}

function load_products_button_header() {
    document.getElementById("products_button_header").onclick = function() {
        window.open("listing.html", '_blank').focus();
    }
}

function load_shop_now_button_header() {
    document.getElementById("shop_now_button_header").onclick = function() {
        go_to_shop("meesho");
    }
}

function setupHeader() {
    load_whatsapp_button();
    load_products_button_header();
    load_shop_now_button_header();
}

export {
    setupHeader
}